"use client"

import { usePathname } from "next/navigation"
import { useEffect, useRef, type ReactNode } from "react"

// Menu mobile sans JavaScript indispensable ; refermé après chaque navigation.
export function MobileMenu({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLDetailsElement>(null)
  const pathname = usePathname()
  useEffect(() => {
    if (ref.current) ref.current.open = false
  }, [pathname])
  return (
    <details ref={ref} className="lg:hidden group relative">
      {children}
    </details>
  )
}
